module.exports = __webpack_public_path__ + "static/cars1-40c9c7810e8b74b5bc1fe075e84db1f0.png";